import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {onCartRes} from './helper';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

import {cartAtom} from 'store';
import {useSetRecoilState} from 'recoil';

const cart = async () => axios.get(Routes.CART);

export const useCart = () => {
  const setCart = useSetRecoilState(cartAtom);

  return useQuery({
    queryKey: [Keys.CART_QRY],
    queryFn: cart,
    onSuccess: res => onCartRes({cart: res.data, setCart}),
    enabled: false,
    retry: false,
  });
};
